<a mat-menu-item (click)="onClick.emit()" class="foreground {{ textColor }}">
  <mat-icon [color]="iconColor" *ngIf="icon">{{ icon }}</mat-icon>
  {{ labelKey | locLabel }}
</a>
